var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"b0a7285e803d891c59ef2c72b166e9761b10d826"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["tribo-flameys-minting@tribo-games"]={id:"b0a7285e803d891c59ef2c72b166e9761b10d826"};
      